import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormControl } from "@angular/forms";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import { LibOptionValue } from "daisy-design-system-front";
import { DropdownComponent } from "../../dropdown/dropdown.component";
import { ExportRequestInterval } from "../../../../../swagger-gen/web-secured/models/export-request-interval";

@Component({
  selector: "app-interval",
  standalone: true,
  imports: [CommonModule, DropdownComponent, TranslateModule],
  templateUrl: "./interval.component.html",
  styleUrls: ["./interval.component.scss"],
})
export class IntervalComponent implements OnInit {
  @Input() valueFormControl = new FormControl<ExportRequestInterval | null>(null);

  @Output() valueChange = new EventEmitter<LibOptionValue<ExportRequestInterval>>();

  public options: LibOptionValue<ExportRequestInterval>[] = [];

  constructor(private readonly translateService: TranslateService) {}

  ngOnInit(): void {
    this.options = Object.values(ExportRequestInterval).map((item) => ({
      value: item,
      label: this.translateService.instant(
        `export-creation.form.granularity.${item.toLowerCase()}`
      ),
    }));
  }
}
